// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__K5","cls2":"CreateSocialItem-cls2_u7M CreateSocialItem-cls1__K5"};